import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Container, Card } from 'reactstrap';
import BusinessGeneralTile from '../business-general-tile/BusinessGeneralTile';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import TutorialTile from './TutorialTile'
import Pagination from '@material-ui/lab/Pagination';
import { makeStyles } from '@material-ui/core/styles';



function EirTutorials(props) {
    const [renderComp, setRenderComp] = useState(false);
    const renderContent = (content) => {
        return { __html: content };
    }

    useEffect(() => {
        setTimeout(() => {
            setRenderComp(true);
        }, 1000);

        if (pageBottom) {
            scrollToRef(myRef);
            setPageBottom(false);
        }
    })
    const myRef = useRef(null);
    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
    const [displayTiles, setDisplayTiles] = React.useState((props.tiles.length > 6) ? props.tiles.slice(0, 6) : props.tiles);

    const [pageBottom, setPageBottom] = React.useState(false);
    const [displayPagination, setdisplayPagination] = React.useState((props.tiles.length > 6) ? true : false);
    const [displayPaginationCount, setdisplayPaginationCount] = React.useState((parseInt(props.tiles.length / 6)) + 1);

    const handleChange = (event, value) => {
        setPageBottom(true);
        setDisplayTiles([]);

        let displayTileFirstIndex = ((value == 1) ? 0 : 6);
        let displayTileLastIndex = (displayTileFirstIndex + 6);


        setDisplayTiles(props.tiles.slice(displayTileFirstIndex, displayTileLastIndex));
        setPage(value);
        moretiles();

    };

    return (
        <div id={"tutorial-ctr-" + props.TutorialOccurence} class="tutorials-main">
            {(!isMobileOnly && renderComp) &&
                <div className='pt-4 pb-5'>
                    <div className="homepage-modules-title" dangerouslySetInnerHTML={renderContent(props.Title)}></div>
                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row>
                            {displayTiles.map((tile, i) => {
                                return (
                                    <Card className="tutorial-card col-12 mb-3">
                                        <TutorialTile tile={tile}></TutorialTile>
                                    </Card>
                                );
                            })
                            }
                        </Row>
                        {displayPagination &&
                            <div ref={myRef} className=" mt-4 d-flex justify-content-center align-items-center">
                                <Pagination count={displayPaginationCount} color="primary" size="large" variant="outlined" onChange={handleChange} />
                            </div>
                        }
                    </Container>
                </div>
            }
        </div>
    );
}
export default EirTutorials;

